import React, { Component } from "react";
import { LocationContainer } from "../containers";
import { Header } from "../components/header";
export class Location extends Component {
  constructor(props) {
    super();
  }

  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <LocationContainer locationID={this.props.match.params.locationID} />
        </div>
      </div>
    );
  }
}
